import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';
import {
  STEPS,
  remoteAccessDialogSetStepReducerType,
  remoteAccessDialogSetDepartmentsReducerType,
  remoteAccessDialogSetIsLoadingReducerType,
} from './RemoteAccessDialogConstants';

export const initialState = Map({
  step: STEPS.INITIAL,
  departments: null,
  isLoading: false,
});

const spec = {
  [remoteAccessDialogSetStepReducerType]: (state, action) => {
    const { step } = action.payload;
    return state.set('step', step);
  },
  [remoteAccessDialogSetDepartmentsReducerType]: (state, action) => {
    const { departments } = action.payload;
    return state.set('departments', departments);
  },
  [remoteAccessDialogSetIsLoadingReducerType]: (state, action) => {
    const { isLoading } = action.payload;
    return state.set('isLoading', isLoading);
  },
};

export default createReducerBySpec(spec, initialState);
